const setPresentationAction = (context, payload) => {
  context.commit('setPresentation', payload)
}

const patchPresentationAction = (context, payload) => {
  context.commit('patchPresentation', payload)
}

export default {
  setPresentationAction,
  setPresentation: setPresentationAction,
  patchPresentationAction,
}
